import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from 'src/app/config';

@Injectable({
  providedIn: 'root',
})
export class LotNaljepniceService {
  constructor(private _http: HttpClient) {}

  dohvatiSkladistaSirovina(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'poslovnicaPopis', a)
      .pipe(map((res: any) => res));
  }

  dohvatiIzvjestajeLotNaljepnica(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'izvjestajLotNaljepnice', a)
      .pipe(map((res: any) => res));
  }
}
